const VALIDATION_RULES = {
  image: {
    types: ['gif', 'png', 'jpg', 'jpeg', 'webp', 'heif', 'heic', 'avif'],
    maxSize: 10485760, // 10MB
  },
  video: {
    types: ['avi', 'mov', 'mp4', 'wmv'],
    maxSize: 100000000, // 100MB
  },
  document: {
    types: [
      'csv',
      'doc',
      'docx',
      'key',
      'num',
      'pag',
      'pdf',
      'ppt',
      'pptx',
      'rtf',
      'txt',
      'xls',
      'xlsx',
      'xml',
    ],
    maxSize: 100000000, // 100MB
  },
  other: {
    types: ['rar', 'zip'],
    maxSize: 100000000, // 100MB
  },
};

VALIDATION_RULES.file = {
  types: [
    ...VALIDATION_RULES.image.types,
    ...VALIDATION_RULES.video.types,
    ...VALIDATION_RULES.document.types,
    ...VALIDATION_RULES.other.types,
  ],
  maxSize: Math.max(
    VALIDATION_RULES.image.maxSize,
    VALIDATION_RULES.video.maxSize,
    VALIDATION_RULES.document.maxSize,
    VALIDATION_RULES.other.maxSize
  ),
};

export function getFileExtension(fileName) {
  if (!fileName || !fileName.includes('.')) {
    return '';
  }
  return fileName.split('.').pop().toLowerCase();
}

// Image Validations (provide file name OR mimetype)
export function isValidImageType(fileName) {
  if (fileName.includes('/') && !fileName.includes('.')) {
    return VALIDATION_RULES.image.types.includes(fileName.replace('image/', ''));
  }
  return VALIDATION_RULES.image.types.includes(getFileExtension(fileName));
}

export function isValidImageSize(file) {
  return file.size <= VALIDATION_RULES.image.maxSize;
}

export function isValidImage(file) {
  return isValidImageSize(file) && isValidImageType(file.name);
}

// File Validations
export function isValidFileType(fileName) {
  if (fileName.includes('/') && !fileName.includes('.')) {
    return false;
  }
  return VALIDATION_RULES.file.types.includes(getFileExtension(fileName));
}
export function isValidFileSize(file) {
  return file.size <= VALIDATION_RULES.file.maxSize;
}
export function isValidFile(file) {
  return isValidFileSize(file) && isValidFileType(file.name);
}
